import React from "react";
import abt1 from "./../Images/website-images/1b.jpeg";
import abt2 from "./../Images/website-images/3b.jpeg";
import abt3 from "./../Images/website-images/2b.jpeg";
import abt4 from "./../Images/website-images/4b.jpeg";
import Frame2 from "../Pages/frame-2";
import Frame from "../Pages/frame";
// import { Link } from 'react-router-dom';

function Blogs() {
  return (
    <>
      <div class="row">
        <div class="col-lg-7">
          <a
            href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_engineering-design-steeldetailing-activity-7063195381949431808-be4H?utm_source=share&utm_medium=member_desktop"
            target="_blank"
            class="blog-box blog-bx "
          >
            <div class="blog-img">
              <img src={abt2} alt="" />
            </div>
            <div class="blog-date">
              <span class="me-3">14-05-2023</span>
              <span></span>
            </div>
            <div class="blog-text">
              <h1>
                {" "}
                Hydrogen refueling at Mathura for Reliance Industries Limited is
                all set to launch. Good to see the journey from Design to
                Finishes..
              </h1>
              <p>
                Max Cantilever upto 8m Congratulations to team IntelBUILD
                Engineering Services LLP BILAL HAJI Aamir Parihar Gauri Kundnani
                Atikah Baig
              </p>
            </div>
          </a>
        </div>
        <div class="col-lg-5 side-blog">
          <div class="scroll-left">
            <a
              href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_construction-engineering-mumbai-activity-7021210280453943296-2zdD?utm_source=share&utm_medium=member_desktop"
              target="_blank"
              className="blog-box blg-sm-line"
            >
              <div class="row">
                <div class="col-4">
                  <div class="small-blg-img">
                    <img src={abt4} alt="" />
                  </div>
                </div>
                <div class="col-8">
                  <div class="blog-date">
                    <span class="me-3">08-2-2023</span>
                    <span></span>
                  </div>
                  <div class="blog-text">
                    <h1>
                      Team IntelBUILD Engineering Services LLP is on inspection
                      of construction of Cargo Platform for Indian Railways at
                      Kalamboli, Navi Mumbai, Maharashtra.{" "}
                    </h1>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_engineering-design-steeldetailing-activity-7063195381949431808-be4H?utm_source=share&utm_medium=member_desktop"
              target="_blank"
              className="blog-box blg-sm-line"
            >
              <div class="row">
                <div class="col-4">
                  <div class="small-blg-img">
                    <img src={abt2} alt="" />
                  </div>
                </div>
                <div class="col-8">
                  <div class="blog-date">
                    <span class="me-3">10-5-2023</span>
                    <span>Category</span>
                  </div>
                  <div class="blog-text">
                    <h1>
                      Believing neglected so so allowance existence departure.
                    </h1>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_mumbai-restaurant-steelbuildings-activity-7021198344576196609-JLK7?utm_source=share&utm_medium=member_desktop"
              target="_blank"
              className="blog-box blg-sm-line"
            >
              <div class="row">
                <div class="col-4">
                  <div class="small-blg-img">
                    <img src={abt3} alt="" />
                  </div>
                </div>
                <div class="col-8">
                  <div class="blog-date">
                    <span class="me-3">18-4-2023</span>
                    <span>Category</span>
                  </div>
                  <div class="blog-text">
                    <h1>
                      Believing neglected so so allowance existence departure.
                    </h1>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_mumbai-restaurant-steelbuildings-activity-7021198344576196609-JLK7?utm_source=share&utm_medium=member_desktop"
              target="_blank"
              className="blog-box blg-sm-line"
            >
              <div class="row">
                <div class="col-4">
                  <div class="small-blg-img">
                    <img src={abt2} alt="" />
                  </div>
                </div>
                <div class="col-8">
                  <div class="blog-date">
                    <span class="me-3">18-4-2023</span>
                    <span>Category</span>
                  </div>
                  <div class="blog-text">
                    <h1>
                      Believing neglected so so allowance existence departure.
                    </h1>
                  </div>
                </div>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/posts/intelbuild-engineering-services-llp_mumbai-restaurant-steelbuildings-activity-7021198344576196609-JLK7?utm_source=share&utm_medium=member_desktop"
              target="_blank"
              className="blog-box blg-sm-line"
            >
              <div class="row">
                <div class="col-4">
                  <div class="small-blg-img">
                    <img src={abt3} alt="" />
                  </div>
                </div>
                <div class="col-8">
                  <div class="blog-date">
                    <span class="me-3">18-4-2023</span>
                    <span>Category</span>
                  </div>
                  <div class="blog-text">
                    <h1>
                      Believing neglected so so allowance existence departure.
                    </h1>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="row">
        

        <div class="row w-100 mx-0">
         
        </div>
        
      </div>
    </>
  );
}

export default Blogs;
